import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Tr,
  Td,
  Table,
  Thead,
  Th,
  Tbody,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";

import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Intake extends React.Component {
  state = {
    startDate: "",
    startDate: "",
    cutOfDate: "",
  };

  setStartDate(date) {
    this.setState({
      startDate: date,
    });
  }

  setEndDate(date) {
    this.setState({
      endDate: date,
    });
  }

  setcutOfDate(date) {
    this.setState({
      cutOfDate: date,
    });
  }

  //Hallam
  //Sunshine
  //Bendigo
  //Ballarat
  //Sale
  //Ridetek

  render() {
    const { startDate, endDate, cutOfDate } = this.state;
    //bg="green.600"
    return (
      <Stack>
        <Center>
          <div className="uiq_tbl_same_bg">
            <Button>Update intake</Button>
            <Button>Intake logs</Button>
            <Button>Print intake info</Button>
            <Button>Import clients from vettrak</Button>
            <Button>Remove all resouces</Button>
          </div>
        </Center>

        <Stack p={3}>
          <Box>
            <div className="uiq_tbl_same_bg">
              <div className="uiq_tr">
                <HStack>
                  <Stack>
                    <Text color="white">Campus</Text>
                    <Menu>
                      <MenuButton
                        as={Button}
                        width="207px"
                        rightIcon={<ChevronDownIcon />}
                      >
                        Hallam
                      </MenuButton>
                      <MenuList>
                        <MenuItem>Hallam</MenuItem>
                        <MenuItem>Sunshine</MenuItem>
                        <MenuItem>Bendigo</MenuItem>
                        <MenuItem>Ballarat</MenuItem>
                        <MenuItem>Ridetek</MenuItem>
                        <MenuItem>Sale</MenuItem>
                      </MenuList>
                    </Menu>
                  </Stack>
                  <Stack>
                    <Text color="white">Cut of date</Text>
                    <DatePicker
                      color="black"
                      selected={cutOfDate}
                      onChange={(date) => this.setcutOfDate(date)}
                    />
                  </Stack>
                </HStack>
                <HStack>
                  <Stack>
                    <Text color="white">Start date</Text>
                    <DatePicker
                      color="black"
                      selected={startDate}
                      onChange={(date) => this.setStartDate(date)}
                    />
                  </Stack>
                  <Stack>
                    <Text color="white">End date</Text>
                    <DatePicker
                      color="black"
                      selected={endDate}
                      onChange={(date) => this.setEndDate(date)}
                    />
                  </Stack>
                </HStack>
              </div>
              <div className="uiq_tr">
                <HStack>
                  <Stack>
                    <Text color="white">Program</Text>
                    <Menu>
                      <MenuButton
                        width="300px"
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                      >
                        Chain of Responsibility
                      </MenuButton>
                      <MenuList>
                        <MenuItem>Yes</MenuItem>
                        <MenuItem>No</MenuItem>
                      </MenuList>
                    </Menu>
                  </Stack>
                </HStack>
                <HStack>
                  <Stack w="89px">
                    <Text color="white">Intake id</Text>
                    <Text color="white">11111</Text>
                  </Stack>
                  <Stack>
                    <Text color="white">Notes</Text>
                    <Button>Click to view/edit</Button>
                  </Stack>
                </HStack>
              </div>
              <div className="uiq_tr">
                <HStack>
                  <Stack>
                    <Text color="white">Min to start</Text>
                    <NumberInput maxW={24}>
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </Stack>
                  <Stack>
                    <Text color="white">Capacity</Text>
                    <NumberInput maxW={24}>
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </Stack>
                </HStack>
                <HStack>
                  <Stack>
                    <Text color="white">Status</Text>
                    <Menu>
                      <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                        Active
                      </MenuButton>
                      <MenuList>
                        <MenuItem>Active</MenuItem>
                        <MenuItem>Cancelled</MenuItem>
                      </MenuList>
                    </Menu>
                  </Stack>
                  <Stack>
                    <Text color="white">Temp?</Text>
                    <Menu>
                      <MenuButton
                        width="90px"
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                      >
                        No
                      </MenuButton>
                      <MenuList>
                        <MenuItem>Yes</MenuItem>
                        <MenuItem>No</MenuItem>
                      </MenuList>
                    </Menu>
                  </Stack>
                </HStack>
              </div>
            </div>
          </Box>
        </Stack>
      </Stack>
    );
  }
}

export default Intake;
